"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[9857],{

/***/ 9857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ popup)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5314);
// components/popup.js



function popup({ wrapper }) {
  const { classes } = window.config

  const selectors = {
    popup: '[data-component="popup"]',
    overlay: '[data-hook="overlay"]'
  }

  // Cache finds the triggers based on what is set to toggle the wrapper
  const cache = {
    $popup: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper),
    $triggers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-toggle="#${wrapper.id}"]`),
    $overlay: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.overlay)
  }

  const lifecycle = {
    change: 'popup:change',
  }

  // Focus trapping state
  const focusState = {
    firstFocusableElement: null,
    lastFocusableElement: null,
    isTrappingFocus: false
  }

  ; (function init() {
    setDefaultAccessibleAttrs()

    // Add click handler for triggers
    cache.$triggers.on('click', function(e) {
      // Only prevent default if NOT an OOS swatch trigger
    if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).hasClass('oos-swatch-trigger')) {
      e.preventDefault();
    }
      cache.$popup.toggleClass(classes.active)
    })

    // Add click handler for overlay
    cache.$overlay.on('click', function(e) {
      e.preventDefault()
      close()
    })

    // Watch for class changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const hasClass = cache.$popup.hasClass(classes.active)
          toggle(hasClass)
        }
      })
    })

    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ['class']
    })

    // Custom Event to close open popup
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('popup:close', close)
  })()

  function setDefaultAccessibleAttrs() {
    // role="dialog"
    cache.$popup.attr('role', 'dialog')
    // Controls
    cache.$triggers.attr('aria-controls', cache.$popup.attr('id'))
  }

  // Focus trapping functions
  function setupFocusTrap() {
    const isFilterDrawer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is('[data-hook="filter-drawer"]');
    const isMobile = window.innerWidth < 768; // md breakpoint
    
    // For filter drawer: only trap focus on mobile
    // For other popups: trap focus on all screen sizes
    if (isFilterDrawer && !isMobile) return;

    // Find all focusable elements within the popup
    const focusableElements = cache.$popup.find(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    ).filter(':visible');

    if (focusableElements.length === 0) return;

    focusState.firstFocusableElement = focusableElements.first()[0];
    focusState.lastFocusableElement = focusableElements.last()[0];
    focusState.isTrappingFocus = true;

    // Focus the first element
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(focusState.firstFocusableElement).focus();

    // Add keyboard event listener for tab navigation
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('keydown.focusTrap', handleTabKey);
    
    // Add escape key handler
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('keydown.escapeKey', handleEscapeKey);
  }

  function removeFocusTrap() {
    const isFilterDrawer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is('[data-hook="filter-drawer"]');
    const isMobile = window.innerWidth < 768; // md breakpoint
    
    // For filter drawer: only remove focus trap on mobile
    // For other popups: remove focus trap on all screen sizes
    if (isFilterDrawer && !isMobile) return;

    focusState.isTrappingFocus = false;
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).off('keydown.focusTrap');
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).off('keydown.escapeKey');
  }

  function handleTabKey(e) {
    if (!focusState.isTrappingFocus) return;
    if (e.key !== 'Tab') return;

    const isShiftTab = e.shiftKey;

    if (isShiftTab && document.activeElement === focusState.firstFocusableElement) {
      // Shift+Tab on first element - focus last element
      e.preventDefault();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(focusState.lastFocusableElement).focus();
    } else if (!isShiftTab && document.activeElement === focusState.lastFocusableElement) {
      // Tab on last element - focus first element
      e.preventDefault();
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(focusState.firstFocusableElement).focus();
    }
  }

  function handleEscapeKey(e) {
    if (e.key !== 'Escape') return;
    
    // Close the popup when Escape is pressed
    close();
  }

  // Popup Events
  function toggle(hasClass) {
    if (hasClass) {
      open()
    } else {
      reset()
    }
  }

  function open() {
    // Close any open popups
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('popup:close', { exclude: [wrapper.id] })

    // 🔒 Lock the scroll only for filter drawer on mobile
    const isFilterDrawer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is('[data-hook="filter-drawer"]');
    const isMobile = window.innerWidth < 768; // md breakpoint
    
    if (isFilterDrawer && isMobile) {
      // Use toggleScroll for filter drawer on mobile
      (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({ lock: true });
    } else if (!isFilterDrawer) {
      // Use toggleScroll for all other popups
      (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({ lock: true });
    }

    // Show overlay
    cache.$overlay.addClass(classes.active)

    // Hide widgets
    if (window.config && window.config.widgetSelectors) {
      window.config.widgetSelectors.forEach(function (selector) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(selector).hide()
      })
    }

    // Setup focus trap for filter drawer on mobile
    setupFocusTrap();

    cache.$popup.trigger(lifecycle.change)
  }

  function close(event, data) {
    if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)) return
    if (data?.exclude?.includes(wrapper.id)) return

    cache.$popup.removeClass(classes.active)
    cache.$triggers.removeClass(classes.active)
  }

  // If all popups are closed reset various UI components
  function reset() {
    const $popups = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.popup)
    const $activePopups = $popups.filter('.' + classes.active)
    const popupsAreActive = $activePopups.length > 0

    if (popupsAreActive) return

    // Remove focus trap
    removeFocusTrap();

    // 🔑 Unlock the scroll
    const isFilterDrawer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is('[data-hook="filter-drawer"]');
    const isMobile = window.innerWidth < 768; // md breakpoint
    
    if (isFilterDrawer && isMobile) {
      // Use toggleScroll for filter drawer on mobile
      (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({ lock: false });
    } else if (!isFilterDrawer) {
      // Use toggleScroll for all other popups
      (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({ lock: false });
    }

    // Hide overlay
    cache.$overlay.removeClass(classes.active)

    // Un-hide widgets
    if (window.config && window.config.widgetSelectors) {
      window.config.widgetSelectors.forEach(function (selector) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(selector).show()
      })
    }
  }
}

/***/ }),

/***/ 5314:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ toggleScroll)
/* harmony export */ });
/**
 * * Applies scroll locked styles to the docuemnt body
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */

function toggleScroll({ lock } = { lock: true }) {
  if (lock) {
    lockScroll()
  } else if (document.body.style.overflow === 'hidden') {
    unlockScroll()
  }
}

function lockScroll() {
  const scrollPosition = window.scrollY

  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollPosition}px`
  document.body.style.width = '100%'
}

function unlockScroll() {
  const scrollPosition = parseInt(document.body.style.top) * -1

  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('position')
  document.body.style.removeProperty('top')
  document.body.style.removeProperty('width')

  if (!scrollPosition) return
  window.scrollTo({ top: scrollPosition, behavior: 'instant' })
}


/***/ })

}]);